// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add all variables here */
:host {
  z-index: 10;
  width: 100%;
  height: 200px;
  position: absolute;
  bottom: 0;
  background-color: #fff;
  border: 1px solid #3d051f;
  padding: 20px 20px;
  text-align: center;
  display: flex;
}

.box-title {
  font-weight: bold;
  font-size: 1.2rem;
  margin-bottom: 20px;
  color: #3d051f;
}

button {
  margin-top: 10px;
  color: white;
  min-width: 200px;
}

.cart-box-content {
  margin-right: auto;
  margin-left: auto;
  display: flex;
}

.centeret {
  align-self: center;
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/content/layout/components/product/add-to-cart/add-to-cart-popup/add-to-cart-popup.component.scss"],"names":[],"mappings":"AAAA,2BAAA;ACEA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AAAF;;AAGA;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cDZc;ACYhB;;AAIA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;AADF;;AAIA;EACE,kBAAA;AADF","sourcesContent":["/* Add all variables here */\n\n@import \"bootstrap/scss/functions\";\n@import \"bootstrap/scss/variables\";\n\n$text-orange: #F7941E;\n$wine-red-light: #5c0a31;\n$wine-red-dark: #3d051f;\n$wine-text-color: #37041c;\n$light-grey: #efefef;\n$yellow-cta: #ff9812;\n$gold: #e0b55d;\n$color-cloud-grey: #F9F9F9;\n$color-grey: #d5d5d5;\n$color-almost-black: #212529;\n$stock-green: #60E040;\n\n$supervin-color-bordeaux: #3E0523;\n\n$color-charcoal-black: #000;\n$theme-colors: (\n  \"primary\": $yellow-cta,\n  \"secondary\": $secondary,\n  \"success\": $yellow-cta, //$success,\n  \"info\": $yellow-cta, //$info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark\n);\n\n$container-max-widths: (\n  xl: 1280px\n);\n\n$header-height: 100px;\n\n$border-divider: 1px solid $color-cloud-grey;\n$breadcrumb-height: 30px;\n\n@mixin supervin-box-shadow {\n  box-shadow: 1px 1px 5px 0 rgba(0,0,0,0.4);\n}\n\n@mixin btn-primary {\n\n  border-radius: 0;\n  text-transform: uppercase;\n  padding: 0.7rem 1.3rem;\n  font-size: 0.8rem;\n  background-color: $yellow-cta;\n  border: solid 1px $yellow-cta;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  line-height: 1.5;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n\n\n","@import \"src/variables\";\n\n:host {\n  z-index: 10;\n  width: 100%;\n  height: 200px;\n  position: absolute;\n  bottom: 0;\n  background-color: #fff;\n  border: 1px solid #3d051f;\n  padding: 20px 20px;\n  text-align: center;\n  display: flex;\n}\n\n.box-title {\n  font-weight: bold;\n  font-size: 1.2rem;\n  margin-bottom: 20px;\n  color: $wine-red-dark;\n\n}\n\nbutton {\n  margin-top: 10px;\n  color: white;\n  min-width: 200px;\n}\n\n.cart-box-content {\n  margin-right: auto;\n  margin-left: auto;\n  display: flex;\n}\n\n.centeret {\n  align-self: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
